var _style, _ellipse, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpinner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\r\n@keyframes a0_t { 0% { transform: translate(20px,20px) rotate(0deg) translate(-16px,-16px); } 50% { transform: translate(20px,20px) rotate(180deg) translate(-16px,-16px); } 100% { transform: translate(20px,20px) rotate(360deg) translate(-16px,-16px); } }\r\n@keyframes a1_t { 0% { transform: translate(20px,20px) scale(1,1); animation-timing-function: cubic-bezier(0.79,-0.295,0.165,1.3); } 50% { transform: translate(20px,20px) scale(3,3); animation-timing-function: cubic-bezier(0.79,-0.295,0.165,1.3); } 100% { transform: translate(20px,20px) scale(1,1); } }\r\n    ")), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.05,
    fill: "#006BFF",
    rx: 20,
    ry: 20,
    transform: "translate(20,20)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(20,20) translate(-16,-16)",
    style: {
      animation: "2s linear infinite both a0_t"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20,34C27.732,34,34,27.732,34,20C34,12.268,27.732,6,20,6C12.268,6,6,12.268,6,20C6,27.732,12.268,34,20,34ZM20,36C28.8366,36,36,28.8366,36,20C36,11.1634,28.8366,4,20,4C11.1634,4,4,11.1634,4,20C4,28.8366,11.1634,36,20,36Z",
    fill: "#006BFF",
    transform: "translate(16,16) translate(-20,-20)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36,20C36,28.8366,28.8366,36,20,36L20,33C27.1797,33,33,27.1797,33,20C33,12.8203,27.1797,7,20,7L20,4C28.8366,4,36,11.1634,36,20Z",
    fill: "#006BFF",
    transform: "translate(24,16) translate(-28,-20)"
  }))), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#006BFF",
    rx: 3,
    ry: 3,
    opacity: 0.3,
    transform: "translate(20,20)",
    style: {
      animation: "2s linear infinite both a1_t"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinner);
export default __webpack_public_path__ + "static/media/spinner.92e78fe698d6a177eb63e5e346d5a780.svg";
export { ForwardRef as ReactComponent };